
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  dict: any;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange, dict }) => {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-1 md:gap-2 mt-6 md:mt-8">
      <button
        className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center bg-[#ffd900] text-[#330052] text-lg md:text-xl disabled:opacity-50${currentPage === 1 ? '' : ' cursor-pointer'}`}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label={dict.previousPage}
      >
        &#60;
      </button>
      {Array.from({ length: totalPages }).map((_, idx) => (
        <button
          key={idx + 1}
          className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center mx-0.5 md:mx-1 text-sm md:text-base transition-all duration-200${' cursor-pointer'}
            ${currentPage === idx + 1
              ? 'bg-white border-2 border-[#330052] text-[#330052] font-bold'
              : 'bg-[#ffd900] text-[#330052] font-bold hover:scale-105'}`}
          onClick={() => onPageChange(idx + 1)}
        >
          {(idx + 1).toString().padStart(2, '0')}
        </button>
      ))}
      <button
        className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center bg-[#ffd900] text-[#330052] text-lg md:text-xl disabled:opacity-50${currentPage === totalPages ? '' : ' cursor-pointer'}`}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label={dict.nextPage}
      >
        &#62;
      </button>
    </div>
  );
};

export default Pagination;
